export enum EventType {
    Pause = 1,
    Resume = 2,
    Rejected = 3,
    Approved  = 4
}
